export enum BadgeSize {
  Small = "small",
  Medium = "medium",
}

export default BadgeSize;
